import templateUrl from 'emun.vendor/vendor-container-full.html'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query'

class VendorContainerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.ytdSales = {
      total: 0,
      count: 0
    };
    let options = {
      url: 'QueryVendors.json',
      pageSize: 15,
      //         filters: [
      //             { groupBy: 'City',maxHeight:200,collapsed:true },
      //             { groupBy: 'State',maxHeight:200,collapsed:true },
      //             { groupBy: 'Zip',maxHeight:200,collapsed:true },
      //],
      criteria: {
        active: true
      },
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: 'Label',
      autoLoad: true,
      append: false,
      sortOptions: {
        'Id': 'Id: Low to High',
        '-Id': 'Id: High to Low',
        'Label': 'Company: A to Z',
        '-Label': 'Company: Z to A',
        'State': 'State: A to Z',
        '-State': 'State: Z to A',
        'Zip': 'Zip: 1 to 9',
        '-Zip': 'Zip: 9 to 1',
      }
    };
    $ctrl.query = new AutoQuery(options);
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }
  viewVendor(rep) {
    this.$state.transitionTo("vendor.dashboard", { vendorId: vendor.id });
  }
}

let VendorContainer = {
  controller: VendorContainerController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
}

export default VendorContainer